import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export class IconTableHead extends Component {
  render() {
    return this.props.tip ? (
      <OverlayTrigger
        placement={this.props.tipPosition || 'right'}
        overlay={<Tooltip>{this.props.tip}</Tooltip>}
      >
        <img
          style={
            this.props.height
              ? { height: this.props.height, borderRadius: '0' }
              : this.props.inTable
              ? { height: '20px', borderRadius: '0' }
              : { height: '25px', borderRadius: '0' }
          }
          alt={this.props.tip}
          src={'/tableIcons/' + this.props.name + '.png'}
          loading="lazy"
        />
      </OverlayTrigger>
    ) : (
      <img
        style={
          this.props.inTable
            ? { height: '20px', borderRadius: '0' }
            : { height: '25px', borderRadius: '0' }
        }
        alt={this.props.name}
        src={'/tableIcons/' + this.props.name + '.png'}
        loading="lazy"
      />
    );
  }
}

export default IconTableHead;
